import { InjectionToken } from '@angular/core';

import { FontApiResponse } from '../entities/font.types';

/**
 * Port the store depends on instead of a concrete HTTP class (ADR 0025): the app binds the
 * HttpClient implementation to this token, a test binds an in-memory fake.
 */
export interface AdminFontsDataPort {
  /** Whole font library with the owner of each font; rejects on transport failure, never hides it. */
  loadFonts(): Promise<FontApiResponse[]>;
  setFontPublic(id: string, isPublic: boolean): Promise<void>;
}

export const ADMIN_FONTS_DATA = new InjectionToken<AdminFontsDataPort>('ADMIN_FONTS_DATA');
